import axiosInstance from './axios';
import type { LoginRequest, RegisterRequest, AuthResponse, User, Tenant } from '../types/api';

export const authApi = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    // Inject appSource to ensure only delivery tenants can log in here
    const data = { ...credentials, appSource: 'livetrack' };
    const response = await axiosInstance.post<AuthResponse>('/auth/login', data);
    return response.data;
  },

  register: async (data: RegisterRequest): Promise<AuthResponse> => {
    const response = await axiosInstance.post<AuthResponse>('/auth/register', data);
    return response.data;
  },

  getCurrentUser: async (): Promise<{ user: User; tenant: Tenant | null }> => {
    const response = await axiosInstance.get('/auth/me');
    return response.data;
  },

  /** Clear the httpOnly JWT cookie on the server */
  logout: async (): Promise<void> => {
    await axiosInstance.post('/auth/logout');
  },
};
